var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMypavilions({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 45,
    viewBox: "0 0 41 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11_1654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4542 0.631393H8.54578C6.33664 0.631393 4.54578 2.42226 4.54578 4.6314V32.3689C4.54578 34.578 6.33664 36.3689 8.54578 36.3689H32.4542C34.6634 36.3689 36.4542 34.578 36.4542 32.3689V4.63139C36.4542 2.42225 34.6634 0.631393 32.4542 0.631393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M8.15442 11.7846C8.15442 14.9553 10.7248 17.5256 13.8955 17.5256C17.0662 17.5256 19.6366 14.9553 19.6366 11.7846C19.6366 8.61387 17.0662 6.0435 13.8955 6.0435C10.7248 6.0435 8.15442 8.61387 8.15442 11.7846Z",
    fill: "#FF725E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9332 11.7846C21.9332 14.9553 24.5036 17.5256 27.6743 17.5256C30.845 17.5256 33.4154 14.9553 33.4154 11.7846C33.4154 8.61387 30.845 6.0435 27.6743 6.0435C24.5036 6.0435 21.9332 8.61387 21.9332 11.7846Z",
    fill: "#E30917"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.15442 25.5641C8.15442 28.7348 10.7248 31.3052 13.8955 31.3052C17.0662 31.3052 19.6366 28.7348 19.6366 25.5641C19.6366 22.3934 17.0662 19.823 13.8955 19.823C10.7248 19.823 8.15442 22.3934 8.15442 25.5641Z",
    fill: "#E30917"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9332 25.5641C21.9332 28.7348 24.5036 31.3052 27.6743 31.3052C30.845 31.3052 33.4154 28.7348 33.4154 25.5641C33.4154 22.3934 30.845 19.823 27.6743 19.823C24.5036 19.823 21.9332 22.3934 21.9332 25.5641Z",
    fill: "#FF725E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11_1654",
    x: 0.545776,
    y: 0.631393,
    width: 39.9084,
    height: 43.7375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11_1654"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11_1654",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMypavilions);
export default __webpack_public_path__ + "static/media/mypavilions.4ed9a00dba25148941d57b77a4e5db28.svg";
export { ForwardRef as ReactComponent };